import { useContext } from 'react';

import categoryProductOptionContext from 'contexts/categoryProductOptionContext';

function useCategoryProductOption() {
  return useContext(categoryProductOptionContext);
}

export default useCategoryProductOption;
